import CurrencyModal from '../modals/currency-modal';
import HomeModal from '../modals/home-modal';
import TicketsModal from '../modals/tickets-modal';
import VisaModal from '../modals/visa-modal';

export const getUsefulMaterialsMock = t => ([
  {
    iconName: 'card',
    previewText: t('fifa2022.useFullMaterialsWidget.visa.snippetText'),
    modalName: VisaModal
  },
  {
    iconName: 'home',
    previewText: t('fifa2022.useFullMaterialsWidget.home.snippetText'),
    modalName: HomeModal
  },
  {
    iconName: 'currency',
    previewText: t('fifa2022.useFullMaterialsWidget.currency.snippetText'),
    modalName: CurrencyModal
  },
  {
    iconName: 'tickets',
    previewText: t('fifa2022.useFullMaterialsWidget.tickets.snippetText'),
    modalName: TicketsModal
  }
]);
